// extracted by mini-css-extract-plugin
export default {"wrapper":"KeamNavigator_wrapper__HPKtn","card1":"KeamNavigator_card1__b-n9h","card2":"KeamNavigator_card2__pX2IH"};